import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TInvoicesResponsePayload,
	TInvoicesStore,
	TFetchPaymentLinkResponsePayload,
	TDownloadInvoicePdfResponsePayload,
	TLastInvoiceStatusResponse,
	TLastInvoiceStatusResponsePayload,
} from './types';

export const getInvoicesState = (state: TStoreState): TInvoicesStore => state.invoices;

export const getInvoicesSelector = getInvoicesState;

// ==========================================:

export const getInvoices = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): TInvoicesResponsePayload => invoices.invoices,
);

// ==========================================:

export const getInvoicesLoader = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): boolean => invoices.invoicesLoader,
);

// ==========================================:

export const getPaymentLink = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): TFetchPaymentLinkResponsePayload => invoices.paymentLink,
);

// ==========================================:

export const getPaymentLinkLoader = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): boolean => invoices.paymentLinkLoader,
);

// ==========================================:

export const getDownloadInvoicePdf = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): TDownloadInvoicePdfResponsePayload => invoices.downloadInvoicePdf,
);

// ==========================================:

export const getDownloadInvoicePdfLoader = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): boolean => invoices.downloadInvoicePdfLoader,
);

// ==========================================:

export const getDownloadInvoiceCsv = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): TDownloadInvoicePdfResponsePayload => invoices.downloadInvoiceCsv,
);

// ==========================================:

export const getDownloadInvoiceCsvLoader = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): boolean => invoices.downloadInvoiceCsvLoader,
);

// ==========================================:

export const getLastInvoiceStatus = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): TLastInvoiceStatusResponsePayload => invoices.lastInvoiceStatus,
);

// ==========================================:

export const getLastInvoiceStatusLoader = createSelector(
	[getInvoicesSelector],
	(invoices: TInvoicesStore): boolean => invoices.lastInvoiceStatusLoader,
);
